import {appAPI} from "../../../api";
import {
    ClientInvoiceStatus,
    IClientInvoice,
    IGetClientInvoicesQuery,
} from "../../../models/IClientInvoice";

const basePath = `/client-invoices`;

export const clientInvoiceAPI = {
    // ── Клиент ────────────────────────────────────────────────────────────

    /** Выписать счёт за текущий день (идемпотентно) */
    issue: async (): Promise<IClientInvoice> => {
        const res = await appAPI.post(`${basePath}/issue`);
        return res.data;
    },

    /** Список своих счетов */
    getMy: async (): Promise<IClientInvoice[]> => {
        const res = await appAPI.get(basePath);
        return res.data;
    },

    /** Один свой счёт */
    getMyById: async (id: string): Promise<IClientInvoice> => {
        const res = await appAPI.get(`${basePath}/${id}`);
        return res.data;
    },

    /** Скачать PDF своего счёта */
    downloadPdf: async (id: string): Promise<Blob> => {
        const res = await appAPI.get(`${basePath}/${id}/pdf`, {
            responseType: "blob",
        });
        return res.data;
    },

    // ── Админ ─────────────────────────────────────────────────────────────

    /** Все счета с фильтрами */
    getAllAdmin: async (query?: IGetClientInvoicesQuery): Promise<IClientInvoice[]> => {
        const res = await appAPI.get(`${basePath}/admin/all`, {params: query});
        // Сервер может вернуть массив или { items, total } — поддержим оба варианта
        return Array.isArray(res.data) ? res.data : (res.data.items ?? []);
    },

    /** Один счёт (любой) */
    getByIdAdmin: async (id: string): Promise<IClientInvoice> => {
        const res = await appAPI.get(`${basePath}/admin/${id}`);
        return res.data;
    },

    /** Скачать PDF любого счёта (админ) */
    downloadPdfAdmin: async (id: string): Promise<Blob> => {
        const res = await appAPI.get(`${basePath}/admin/${id}/pdf`, {
            responseType: "blob",
        });
        return res.data;
    },

    /** Сменить статус счёта */
    updateStatus: async (
        id: string,
        status: ClientInvoiceStatus,
    ): Promise<IClientInvoice> => {
        const res = await appAPI.patch(`${basePath}/admin/${id}/status`, {status});
        return res.data;
    },
};